import { Observable } from 'rxjs'
import { map, switchMap, take } from 'rxjs/operators'

import { Featured, getTranslatedString } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { ThesaurusTermDataStore } from '@skinsoft/entity'
import { HistoryRecord } from '@skinsoft/ui'


export function resolveDescription(
    source$: Observable<Featured | HistoryRecord>,
    locale: string,
): Observable<Featured | HistoryRecord> {
    const thesaurusDataStore = ThesaurusTermDataStore.getInstance();
    return source$.pipe(
        switchMap(featured => {
            if (!featured.description) {
                return source$;
            }

            return thesaurusDataStore.fetchOne(featured.description as string).pipe(
                take(1),
                map(thesaurusTerm => ({
                    ...featured,
                    description: getTranslatedString(
                        thesaurusTermSelectors.preferredTerm(thesaurusTerm),
                        locale
                    )
                })),
            );
        }),
    );
}
